import { Dialog } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { DetailsItem } from 'components';
import { useOpenable } from 'hooks';
import IPosition from 'types/Position';
import { useFeatureFlags } from 'utils/features';
import { executeFunctionsCurried } from 'utils/functionUtils';
import { t } from 'utils/localize';
import PositionDetailsProgressForm, { IPositionDetailsProgressFormProps } from '../forms/PositionDetailsProgressForm';
import { positionsValueString } from '../util/util';

export interface IPositionDetailsProgressDetailProps
  extends Omit<IPositionDetailsProgressFormProps, 'onSubmit' | 'subtitle' | 'positionId'> {
  className?: ClassName;
  position: IPosition;
  editable: boolean;
  onUpdate: () => Promise<void>;
}

const PositionDetailsProgressDetail = (props: IPositionDetailsProgressDetailProps) => {
  const { className, editable, position, onUpdate, ...formProps } = props;

  const progressReportIsEnabled = useFeatureFlags('WORK_ACCOMPLISHED');
  const dialogOpenable = useOpenable();

  const classes = classNames('position-details-progress-detail', className);

  return (
    <>
      {progressReportIsEnabled && (
        <>
          <DetailsItem
            className={classes}
            title={t('Manage Progress')}
            onClick={dialogOpenable.open}
            disabled={!editable}
            hint={t('View, create, edit, and delete progress entries.')}
            value={
              position.canManageProjectCostCodeQuantity
                ? positionsValueString(position.canManageProjectCostCodeQuantity)
                : '---'
            }
          />
          <Dialog position={'center'} isOpen={dialogOpenable.isOpen} onClose={dialogOpenable.close}>
            <PositionDetailsProgressForm
              className="mt-4 p-8"
              position={position}
              onSubmit={executeFunctionsCurried(onUpdate, dialogOpenable.close)}
              {...formProps}
            />
          </Dialog>
        </>
      )}
    </>
  );
};

export default PositionDetailsProgressDetail;
